import React from "react";
import { ShipmentStatus, ShipmentStatusColorMap } from "@/utils/enum";

const ShipmentStatusMapper = {
  [ShipmentStatus.Draft]: {
    title: "Created Shipment",
    color: "#000",
  },
  [ShipmentStatus.Pending]: {
    title: "Pending Quotes",
    color: "#000",
  },
  [ShipmentStatus.Completed]: {
    title: "Quoted",
    color: "#000",
  },
  [ShipmentStatus.Posted]: {
    title: "Posted",
    color: ShipmentStatusColorMap[ShipmentStatus.Posted],
  },
  [ShipmentStatus.Assigned]: {
    title: "Assign/In-Transit",
    color: ShipmentStatusColorMap[ShipmentStatus.Assigned],
  },
  [ShipmentStatus.Delivered]: {
    title: "Delivered",
    color: ShipmentStatusColorMap[ShipmentStatus.Delivered],
  },
  [ShipmentStatus.Incomplete]: {
    title: "Incomplete",
    color: "#000",
  },
};

export default function ShipmentStatusLabel({ status }) {
  if (!status) return null;

  const currentStatus = ShipmentStatusMapper[status];

  if (!currentStatus) return null;

  return (
    <span
      style={{
        fontWeight: 600,
        color: currentStatus.color,
      }}
    >
      {currentStatus.title}
    </span>
  );
}
